// extracted by mini-css-extract-plugin
module.exports = {"compareToolWrapper":"compareToolModal_compareToolWrapper__kpFA7"};